import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import {
  CommunityVotePage,
  MainnetNodePage,
  ErrorPage,
  HomePage,
} from '../../pages';
import { DefaultLayout } from '../../layouts';

export const HippoRouterProvider = () => {
  const router = createBrowserRouter([
    {
      id: 'root',
      path: '/',
      errorElement: <ErrorPage />,
      Component: DefaultLayout,
      children: [
        {
          index: true,
          path: '/',
          Component: HomePage,
        },
        {
          path: '/hippocratCommunityVote',
          Component: CommunityVotePage,
        },
        {
          path: '/mainnetNode',
          Component: MainnetNodePage,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} fallbackElement={<></>} />;
};
